/**
 * View Model for the WordChoice component.
 */
export default class WordChoice {
  constructor(attrs = {}) {
    Object.assign(this, {
      value: '',
      used: false,
    }, attrs);
  }

  /**
   * Sets the word choice to being available.
   */
  free() {
    this.used = false;
  }

  /**
   * Sets a word choice to being used. Note, a word choice that
   * is not free can only be used once.
   */
  use() {
    if (this.used) {
      throw new Error('WordChoice is in use.');
    }

    this.used = true;
  }
}
